// extracted by mini-css-extract-plugin
export var hideEditor = "_hu-2";
export var infoIcon = "_hu-3";
export var label = "_hu-1";
export var labelContainer = "_hu-0";
export var readonlyText = "_hu-4";